import React from "react";
import { FaFacebook, FaTwitter, FaWhatsapp } from "react-icons/fa";

export default function OurTeamprops(props) {
  return (
    <div className="TCard" data-aos="flip-up">
      <div className="card center2">
        <img
          src="https://www.citypng.com/public/uploads/small/11639594348a46oiqppgm5q073rktaaxu4szgn0lvrp0eq0j39kqc08skbq931nzhc8ogm7bvemplm5uzurkb29ohqernyblwsoelhbbmmmgzxb.png"
          alt="ProfileImage"
        />
        <div className="card-content">
          <h3>{props.position}</h3>
          <h4>{props.name}</h4>
          <p>{props.contact}</p>
        </div>
        <div className="card-social-icons">
          <a href="/" target="_blank">
            <FaFacebook />
          </a>
          <a href="/" target="_blank">
            <FaTwitter />
          </a>
          <a href="/" target="_blank">
            <FaWhatsapp />
          </a>
        </div>
      </div>
    </div>
  );
}
